<script lang="ts" setup>
    import { useNavigationStore } from '@/js/stores/navigation';
    import { computed } from 'vue';
    import { RouterLink, useRoute } from 'vue-router';
    import EchoTooltip from '../EchoTooltip.vue';

    const props = defineProps<{
        to?: string;
        href?: string;
        label: string;
    }>();

    const navigation = useNavigationStore();

    const route = useRoute();

    const isActive = computed(() => (props.to ? route.path.startsWith(props.to) : false));

    const linkClass = computed(() => {
        let baseClass =
            'flex items-center gap-3 custom-focus rounded-sm px-2.5 py-2 hover:bg-gray-lightest';

        if (props.to) {
            baseClass += isActive.value
                ? ' bg-gray-lightest hover:bg-gray-lightest'
                : ' text-gray-dark';
        } else if (props.href) {
            baseClass += ' text-gray-dark';
        }

        return baseClass;
    });
</script>

<template>
    <li>
        <EchoTooltip :label="props.label" position="right" :disabled="navigation.visible">
            <RouterLink v-if="props.to" :to="props.to" :class="linkClass">
                <div class="self-start">
                    <slot name="icon" />
                </div>
                <span v-if="navigation.visible">{{ props.label }}</span>
            </RouterLink>

            <a
                v-else-if="props.href"
                :href="props.href"
                :class="linkClass"
                target="_blank"
                rel="noopener noreferrer"
            >
                <div class="self-start">
                    <slot name="icon" />
                </div>
                <span v-if="navigation.visible">{{ props.label }}</span>
            </a>
        </EchoTooltip>
    </li>
</template>
